import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {contractsUtils} from "../../../../infrastructure/utils/contracts-utils";
import {TvNetworkDomainModel} from "../models/tv-network-domain-model";
import {TvNetworkViewModel} from "../models/tv-network-view-model";
import {TvNetworkApiModel} from "../models/tv-network-api-model";
import {BookmakerApiModel} from "../../bookmaker/models/bookmaker-api-model";
import {CountryDomainModel} from "../../country/models/country-domain-model";
import {CountryViewModel} from "../../country/models/country-view-model";
import {BookmakerDomainModel} from "../../bookmaker/models/bookmaker-domain-model";
import {BookmakerViewModel} from "../../bookmaker/models/bookmaker-view-model";
import {CountryFactory} from "../../country/domain-services/country-factory";
import {BookmakerFactory} from "../../bookmaker/domain-services/bookmaker-factory";
import {TvNetworkImageRequestParams} from "../models/tv-network.image-request-params";
import {LoggerUtils} from "../../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../../infrastructure/utils/terms-utils";

export class TvNetworkFactory extends BaseFactory {
  countryFactory: CountryFactory;
  bookmakerFactory: BookmakerFactory;

  static injectables = [LoggerUtils, TermsUtils, CountryFactory, BookmakerFactory];

  constructor(logger: LoggerUtils, terms: TermsUtils, countryFactory: CountryFactory, bookmakerFactory: BookmakerFactory) {
    super(logger, terms);

    contractsUtils.requiredType(countryFactory, CountryFactory);
    contractsUtils.requiredType(bookmakerFactory, BookmakerFactory);

    this.countryFactory = countryFactory;
    this.bookmakerFactory = bookmakerFactory;
  }

  createDomainModel(apiModel: TvNetworkApiModel, bookmakers: Array<BookmakerApiModel>, countriesMap: Map<Number, CountryDomainModel>): TvNetworkDomainModel {
    const countryDomainModel: CountryDomainModel = countriesMap.get(apiModel.countryId);
    const tvNetworkBookmakerApi: BookmakerApiModel = bookmakers?.find((bookmaker: BookmakerViewModel) => bookmaker.id === apiModel.bookmakerId);
    const tvNetworkBookmakerDomain: BookmakerDomainModel = tvNetworkBookmakerApi ? this.bookmakerFactory.createDomainModel(tvNetworkBookmakerApi) : null;
    const domain: TvNetworkDomainModel =  new TvNetworkDomainModel(apiModel, tvNetworkBookmakerDomain, countryDomainModel);

    return domain;
  }

  createVM(model: TvNetworkDomainModel): TvNetworkViewModel {
    const tvNetworkCountryView: CountryViewModel = model.country ? this.countryFactory.createDomainModel(model.country) : null;
    const tvNetworkBookmakerView: BookmakerViewModel = model.bookmaker ? this.bookmakerFactory.createDomainModel(model.bookmaker) : null;
    const iconUrl = new TvNetworkImageRequestParams(model.id);

    const vm = new TvNetworkViewModel(model, tvNetworkCountryView, tvNetworkBookmakerView, iconUrl);

    return vm;
  }
}
